import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, Ref } from "vue";
import MatchList from "./MatchList.vue"
import dayjs from "dayjs";
import { ClassList } from "@/model/matchModel";
import { getMatchv6 } from "@/api/php/match";
import EventBus from "@/uitls/EventBus";

import { useI18n } from 'vue-i18n'
interface dataProps {
    nav_type: any;
    offset_top: any;
}

export default /*#__PURE__*/_defineComponent({
  name: 'MatchTabs',
  props: {
    nav_type: { type: null, required: true },
    offset_top: { type: null, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
    nav_type: any;
    offset_top: any;
}

_useCssVars(_ctx => ({
  "1c7a8099-primaryColor": (_unref(primaryColor))
}))

//二级分类
const { t } = useI18n()





let state = ref("1");
const tabchange = () => {
    //   tab改变时
    // EventBus.emit("changeIndex");
};
onMounted(() => {
    let element: HTMLElement = document.querySelector('.tabs .van-tabs__wrap') as HTMLElement;
    element.onclick = e => {  //只能是箭头函数，不然this指向不对
        const target = e.target as HTMLTextAreaElement
        if (target.className === 'van-tabs__wrap') {  //除了'+'其他都是van-tab__text
            show.value = true;
        }
    }
    getData()


})
const classList: Ref<ClassList[]> = ref([])
var dateList;
const getData = async () => {
    const v: any = await getMatchv6({
        nav_type: props.nav_type,
        competition_id: 0,
        match_type: 0,
        page: 1,
        date: "",
        limit: 20
    })
    if (v.code == 200) {
        dateList = v.data.date_list
        classList.value = v.data.class_list;
    }
}


//检查月份有多少天
const monthNum = (year, month) => {
    let monthDayTotal = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31] //默认闰年
    let nowMonthIdx = month //当前月的下标
    if (year % 4 == 0 && year % 100 != 0 || year % 400 == 0) { //闰年
        return monthDayTotal[nowMonthIdx] //当前月的天数
    } else { //平年
        monthDayTotal = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
        return monthDayTotal[nowMonthIdx] //当前月的天数
    }
}

const date = ref('');
const show = ref(false);
const nowYear = ref(dayjs().year());
const nowMonth = ref(dayjs().month())
const minDate = ref(new Date(nowYear.value, nowMonth.value, 1));
const maxDate = ref(new Date(nowYear.value, nowMonth.value, monthNum(nowYear.value, nowMonth.value)));

const formatDate = (date) => {
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    if (month < 10) {
        month = `0${month}`
    }
    if (day < 10) {
        day = `0${day}`
    }
    return `${year}-${month}-${day}`
};
const onConfirm = (value) => {
    show.value = false;
    date.value = formatDate(value);
    EventBus.emit("matchConfirmDate", date.value)
};
const formatter = (day) => {

    let month = day.date.getMonth() + 1;
    let date = day.date.getDate();
    const year = day.date.getFullYear();

    if (month == dayjs().month() + 1) {
        if (date === dayjs().date()) {
            day.text = t('match.nowDay');
            // day.bottomInfo = '12场';
        } else {
            day.bottomInfo = t('match.no');
        }
    } else {
        day.bottomInfo = t('match.no');
    }
    if (month < 10) {
        month = `0${month}`
    }
    if (date < 10) {
        date = `0${date}`
    }

    const dayStr = `${year}-${month}-${date}`;
    for (const key in dateList) {
        if (Object.prototype.hasOwnProperty.call(dateList, key)) {
            const element = dateList[key];
            if (dayStr == key) {
                day.bottomInfo = `${element}${t('match.chang')}`
            }
        }
    }


    return day;
}

const subtitleLeft = () => {
    nowMonth.value--;
    if (nowMonth.value < 0) {
        nowMonth.value = 0
    }
    minDate.value = new Date(nowYear.value, nowMonth.value, 1);
    maxDate.value = new Date(nowYear.value, nowMonth.value, monthNum(nowYear.value, nowMonth.value));

}
const subtitleRight = () => {
    nowMonth.value++;
    if (nowMonth.value > 11) {
        nowMonth.value = 0
    }
    console.log(nowMonth.value);

    minDate.value = new Date(nowYear.value, nowMonth.value, 1);
    maxDate.value = new Date(nowYear.value, nowMonth.value, monthNum(nowYear.value, nowMonth.value));

}

const primaryColor = process.env.VUE_APP_PRIMARY_COLOR as string;

const __returned__ = { t, props, state, tabchange, classList, dateList, getData, monthNum, date, show, nowYear, nowMonth, minDate, maxDate, formatDate, onConfirm, formatter, subtitleLeft, subtitleRight, primaryColor, MatchList }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})